import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changes, fields } from 'src/components/utils/fields'
import { formatDateForInput } from 'src/components/utils/dateFormatter';
import { useMediaQuery } from '@mui/material'
import { BufferService, LoadingContext, M_Button, M_Fieldset, M_Header, M_MessageBoard, NavigateContext } from 'src/M_Components'
import { Book, Refresh, TimerOutlined } from '@mui/icons-material'



const motherBoundMap = {
    'e': 'Export', 'E': 'Export',
    'i': 'Import', 'I': 'Import',
    't': 'Transit', 'T': 'Transit',
    'n': 'Internal', 'N': 'Internal',
    'p': 'Operations', 'P': 'Operations',
    'o': 'Other', 'O': 'Other',
    }
export const DemurrageControlCrud = () => {
    const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const [data, setData] = useState({})
    const [open, setOpen] = useState(false)
    const [passedRow, setPassedRow] = useState({})
    const [operation, setOperation] = useState('')
    const [isFirstTime, setIsFirstTime] = useState(true)
    const [leavingPage, setLeavingPage] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [editingId, setEditingId] = useState(null) 

    const accountService = new BufferService('Account')
    const bookingEquipmentService = new BufferService('BookingEquipment')
    const bookingService = new BufferService('Booking')
    const tradeService = new BufferService('Trade')
    const voyageService = new BufferService('Voyage')

    const equipmentService = new BufferService('Equipment', 'secondary')
    const movementService = new BufferService('Movement', 'secondary')
    const demurrageService = new BufferService('Demurrage', 'secondary')
    const demurrageRuleService = new BufferService('DemurrageRule', 'secondary')
    const demurrageControlService = new BufferService('DemurrageControl', 'secondary')  // ← change 1

    // change 2 — available controls and rules state
    const [availableControls, setAvailableControls] = useState([])
    const [availableRules, setAvailableRules] = useState([])

    const sessionKeys = ['operation', 'data', 'open', 'passedRow', 'leavingPage']

    const matches = useMediaQuery('(min-width:1800px)')
    const matches2 = useMediaQuery('(min-width:1700px)')
    const matches3 = useMediaQuery('(min-width:1490px)')
    const matches4 = useMediaQuery('(min-width:1450px)')
    const matches5 = useMediaQuery('(min-width:1420px)')
    const matches6 = useMediaQuery('(min-width:1380px)')
    const matches7 = useMediaQuery('(min-width:1280px)')
    const matches8 = useMediaQuery('(min-width:1230px)')
    const matches9 = useMediaQuery('(min-width:1190px)')
    const matches10 = useMediaQuery('(min-width:1150px)')
    const matches11 = useMediaQuery('(min-width:970px)')
    const matches12 = useMediaQuery('(min-width:930px)')
    const matches13 = useMediaQuery('(min-width:850px)')
    const matches14 = useMediaQuery('(min-width:870px)')
    const matches15 = useMediaQuery('(min-width:615px)')
    const matches16 = useMediaQuery('(min-width:440px)')

    const handleForeignDate = (data, field, obj) => {
        field.fields?.forEach(keyValue => {
            let value = obj && obj[keyValue.key] || ''
            
            if (keyValue.key === 'Date' && value) {
                value = formatDateForInput(value)
            }
            
            changes(keyValue.value, value, setData)
        })
    }
    const handleTradeReturn = (data, field, obj) => {
        field.fields?.forEach(keyValue => {
            let value = obj && obj[keyValue.key] || ''
            if (keyValue.value === 'motherBound') {
                value = motherBoundMap[value] || value
            }
            changes(keyValue.value, value, setData)
        })
    }

    // Options
    const motherBoundOptions = [
        { label: t('Export'), value: 'Export' },
        { label: t('Import'), value: 'Import' },
        { label: t('Transit'), value: 'Transit' },
        { label: t('Internal'), value: 'Internal' },
        { label: t('Operations'), value: 'Operations' },
        { label: t('Other'), value: 'Other' },
    ]
    
    const demurrageStatusOptions = [
        { label: t('None'), value: 'None' },
        { label: t('Partial'), value: 'Partial' },
        { label: t('Clear'), value: 'Clear' },
    ]
    const terminalStatusOptions = [
        { label: t('None'), value: 'None' },
        { label: t('Partial'), value: 'Partial' },
        { label: t('Clear'), value: 'Clear' },
    ]
    const discountTypeOptions = [
        { label: t('None'), value: 'None' },
        { label: t('Percentage'), value: 'Percent' },
        { label: t('FixedDiscount'), value: 'FixedDiscount' },
        { label: t('FixedPrice'), value: 'FixedPrice' },
    ]

    // change 7 — added demuControlId to fieldOptionsMap
    const fieldOptionsMap = {
        'demurrageStatus': demurrageStatusOptions,
        'terminalStatus': terminalStatusOptions,
        'discountType': discountTypeOptions,
        'demuControlId': availableControls,
    };
    const fieldFilterMap = {
        'prefix': data.eqTypeID ? `EquipmentTypeCode eq '${data.eqTypeID}'` : null,
        'number': data.eqTypeID ? `EquipmentTypeCode eq '${data.eqTypeID}'` : null,
        'cd': data.eqTypeID ? `EquipmentTypeCode eq '${data.eqTypeID}'` : null,
    }

    // Fields
    const BookingFields = [
        { display: t('Line Code'), required: true,  code: 'lineCode', type: 'foreignKey', entity: 'Trade', filterField: 'TradeLineName', labelFields: ['TradeLineName'], fields: [{ key: 'TradeLineName', value: 'lineCode' }, { key: 'TradeCode', value: 'mServiceCode' },{ key: 'TradeBound', value: 'motherBound' },{ key: 'Id', value: 'lineCodeId' }], returnFunc: handleTradeReturn },
        { display: t('M. Service Code'), required: true, code: 'mServiceCode', type: 'foreignKey', entity: 'Trade', filterField: 'TradeCode', labelFields: ['TradeCode'], fields: [{ key: 'TradeCode', value: 'mServiceCode' }, { key: 'TradeLineName', value: 'lineCode' },{ key: 'TradeBound', value: 'motherBound' },{ key: 'Id', value: 'lineCodeId' }], returnFunc: handleTradeReturn },
        { display: t('Mother Bound'), required: true, code: 'motherBound', type: 'select', options: 'motherBoundOptions', extraField: 'motherBoundValue' },

        { display: t('M. Voyage'), required: true, code: 'voyage', type: 'foreignKey', entity: 'Voyage', filterField: 'VoyageNumber', labelFields: ['VoyageNumber'], fields: [{ key: 'VoyageNumber', value: 'voyage' }, { key: 'Id', value: 'voyageId' }], },

        // change 4 — added returnFunc to clear dependent fields on booking change
        { 
            display: t('Bk. Proc. Key'), 
            required: true, 
            code: 'bkProcKey', 
            type: 'foreignKey', 
            entity: 'Booking', 
            filterField: 'ProcessKey', 
            labelFields: ['ProcessKey'], 
            fields: [
                { key: 'ProcessKey', value: 'bkProcKey' },
                { key: 'BookingNumber', value: 'bookingNumber' },
                { key: 'Id', value: 'bookingId' }
            ],
            returnFunc: (data, field, obj) => {
                field.fields?.forEach(keyValue => {
                    changes(keyValue.value, obj && obj[keyValue.key] || '', setData)
                })
                changes('demuControlId', '', setData)
                changes('demuControlIdValue', '', setData)
            }
        },

        // change 4 — added returnFunc to clear dependent fields on booking change
        { 
            display: t('Booking Number'), 
            required: true, 
            code: 'bookingNumber', 
            type: 'foreignKey', 
            entity: 'Booking', 
            filterField: 'BookingNumber', 
            labelFields: ['BookingNumber'], 
            fields: [
                { key: 'BookingNumber', value: 'bookingNumber' },
                { key: 'ProcessKey', value: 'bkProcKey' },
                { key: 'Id', value: 'bookingId' }
            ],
            returnFunc: (data, field, obj) => {
                field.fields?.forEach(keyValue => {
                    changes(keyValue.value, obj && obj[keyValue.key] || '', setData)
                })
                changes('demuControlId', '', setData)
                changes('demuControlIdValue', '', setData)
            }
        },

        { 
            display: t('Eq. Type ID'), 
            required: true, 
            code: 'eqTypeID', 
            type: 'foreignKey', 
            entity: 'EquipmentType', 
            api:'secondary', 
            filterField: 'Code', 
            labelFields: ['Code'], 
            fields: [
                { key: 'Code', value: 'eqTypeID' }, 
                { key: 'Id', value: 'equipmentTypeId' }
            ],
            returnFunc: (data, field, obj) => {
                field.fields?.forEach(keyValue => {
                    changes(keyValue.value, obj && obj[keyValue.key] || '', setData)
                })
                changes('prefix', '', setData)
                changes('number', '', setData)
                changes('cd', '', setData)
                changes('equipmentId', '', setData)
            }
        },

        { 
            display: t('Prefix'), 
            code: 'prefix', 
            type: 'foreignKey', 
            entity: 'Equipment', 
            api:'secondary', 
            filterField: 'Prefix', 
            labelFields: ['Prefix'], 
            fields: [
                { key: 'Prefix', value: 'prefix' },
                { key: 'Number', value: 'number' },
                { key: 'CheckDigit', value: 'cd' },
                { key: 'EquipmentTypeId', value: 'equipmentTypeId' },
                { key: 'EquipmentTypeCode', value: 'eqTypeID' },
                { key: 'InsideLength', value: 'insideLength' },
                { key: 'Id', value: 'equipmentId' }
            ]
        },
        { 
            display: t('Number'), 
            required: true, 
            code: 'number', 
            type: 'foreignKey', 
            entity: 'Equipment', 
            api:'secondary', 
            filterField: 'Number', 
            labelFields: ['Number'], 
            fields: [
                { key: 'Prefix', value: 'prefix' },
                { key: 'Number', value: 'number' },
                { key: 'CheckDigit', value: 'cd' },
                { key: 'EquipmentTypeId', value: 'equipmentTypeId' },
                { key: 'EquipmentTypeCode', value: 'eqTypeID' },
                { key: 'InsideLength', value: 'insideLength' },
                { key: 'Id', value: 'equipmentId' }
            ]
        },
        { 
            display: t('CD'), 
            required: true, 
            code: 'cd', 
            type: 'foreignKey', 
            entity: 'Equipment', 
            api:'secondary', 
            filterField: 'CheckDigit', 
            labelFields: ['CheckDigit'], 
            fields: [
                { key: 'Prefix', value: 'prefix' },
                { key: 'Number', value: 'number' },
                { key: 'CheckDigit', value: 'cd' },
                { key: 'EquipmentTypeId', value: 'equipmentTypeId' },
                { key: 'EquipmentTypeCode', value: 'eqTypeID' }, 
                { key: 'InsideLength', value: 'insideLength' },
                { key: 'Id', value: 'equipmentId' }
            ]
        },

        // change 5 — renamed label from 'Demu Key' to 'Demurrage Rule Key'
        { display: t('Demurrage Rule Key'), required: true, code: 'demuKey', type: 'foreignKey', entity: 'DemurrageRule', api:'secondary' , filterField: 'Key', labelFields: ['Key'], fields: [{ key: 'Key', value: 'demuKey' }, { key: 'Description', value: 'description' }, { key: 'Id', value: 'demuKeyId' }], },
        { display: t('Description'), code: 'description', type: 'disabled', },

        { type: 'separator' }, { display: t('Booking Comments'), code: 'bookingComments', type: 'textArea', fullWidth: true }
    ]
    const DemurrageFields = [
        { display: t('StartDate'), required: true, code: 'startDate', type: 'date' },
        { display: t('Start Move Code'), code: 'startMoveCode', type: 'foreignKey', entity: 'Movement', api:'secondary', filterField: 'Status', labelFields: ['Status'], fields: [{ key: 'Status', value: 'startMoveCode' },{ key: 'MovementTypeId', value: 'startMoveKey' },{ key: 'Date', value: 'startDate' },{ key: 'Id', value: 'startMovementId' }], returnFunc: handleForeignDate },
        { display: t('Start Move Key'), code: 'startMoveKey', type: 'foreignKey', entity: 'Movement', api:'secondary', filterField: 'Status', labelFields: ['Status'], fields: [{ key: 'Status', value: 'startMoveKey' },{ key: 'MovementTypeId', value: 'startMoveKey' }, { key: 'Date', value: 'startDate' },{ key: 'Id', value: 'startMovementId' }], returnFunc: handleForeignDate },
        
        { display: t('Mid Date'), code: 'midDate', type: 'date' },
        { display: t('Mid Move Code'), code: 'midMoveCode', type: 'foreignKey', entity: 'Movement', api:'secondary', filterField: 'Status', labelFields: ['Status'], fields: [{ key: 'Status', value: 'midMoveCode' },{ key: 'MovementTypeId', value: 'midMoveKey' }, { key: 'Date', value: 'midDate' },{ key: 'Id', value: 'midMovementId' }],  returnFunc: handleForeignDate },
        { display: t('Mid Move Key'), code: 'midMoveKey', type: 'foreignKey', entity: 'Movement', api:'secondary', filterField: 'Status', labelFields: ['Status'], fields: [{ key: 'Status', value: 'midMoveKey' },{ key: 'MovementTypeId', value: 'midMoveKey' }, { key: 'Date', value: 'midDate' },{ key: 'Id', value: 'midMovementId' }],  returnFunc: handleForeignDate},
        
        { display: t('End Date'), code: 'endDate', type: 'date' },
        { display: t('End Move Code'), code: 'endMoveCode', type: 'foreignKey', entity: 'Movement', api:'secondary', filterField: 'Status', labelFields: ['Status'], fields: [{ key: 'Status', value: 'endMoveCode' },{ key: 'MovementTypeId', value: 'endMoveKey' },{ key: 'Date', value: 'endDate' },{ key: 'Id', value: 'endMovementId' }], returnFunc: handleForeignDate },
        { display: t('End Move Key'), code: 'endMoveKey', type: 'foreignKey', entity: 'Movement', api:'secondary', filterField: 'Status', labelFields: ['Status'], fields: [{ key: 'Status', value: 'endMoveKey' },{ key:'MovementTypeId', value:'endMoveKey'}, { key: 'Date', value: 'endDate' },{ key:'Id', value:'endMovementId'}], returnFunc: handleForeignDate },

        { display: t('Demurrage Status'), required: true, code: 'demurrageStatus', type: 'select', options: 'demurrageStatusOptions', extraField: 'demurrageStatusValue' },
        { display: t('Terminal Status'), required: true, code: 'terminalStatus', type: 'select', options: 'terminalStatusOptions', extraField: 'terminalStatusValue' },

        { display: t('Account ID'),  code: 'accountID', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'accountID' }, { key: 'Id', value: 'accountId' }], },
        { display: t('Client Code'),  code: 'clientCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'clientCode' }, { key: 'Id', value: 'clientCodeId' }], },
        { display: t('Invoice Code'),  code: 'invoiceCode', type: 'foreignKey', entity: 'Account', filterField: 'AccountCode', labelFields: ['AccountCode'], fields: [{ key: 'AccountCode', value: 'invoiceCode' }, { key: 'Id', value: 'invoiceCodeId' }], },

        { display: t('Cost'),  code: 'cost', type: 'decimal' },
        { display: t('Fixed Cost'), type: 'checkBox', code: 'fixedCost' },
        { display: t('Free Days'), code: 'freeDays', type: 'number' },

        { display: t('Price / Discount'), code: 'priceDiscount', type: 'decimal' },
        { display: t('Discount Type'), code: 'discountType', type: 'select', options:   'discountTypeOptions', extraField: 'discountTypeValue' },

        // change 6 — added demuControlId as select driven by availableControls
        //{ display: t('Demurrage Control'), code: 'demuControlId', type: 'select', options: 'demuControlId', extraField: 'demuControlIdValue' },
    ]


    useEffect(() => {
        if (isFirstTime) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstTime(false)
            sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))

            const editingDemurrage = JSON.parse(sessionStorage.getItem('editingDemurrage'))
            const operationType = sessionStorage.getItem('operationType')
            
            if (editingDemurrage && (operationType === 'Edit' || operationType === 'Copy')) {
                editOrCopyDemurrage(editingDemurrage.Id, operationType === 'Copy')
                sessionStorage.removeItem('editingDemurrage')
                sessionStorage.removeItem('operationType')
            } else if (operationType === 'Create') {
                setOperation('Create')
                sessionStorage.removeItem('operationType')
            }
        }
    }, [])

    useEffect(() => {
        const newId = sessionStorage.getItem('selectedTab')
        if (newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    })

    useEffect(() => {
        sessionKeys.forEach((key) => {
            sessionStorageMachine(id, key, key)
        })
        // eslint-disable-next-line
    }, [id, operation, data, leavingPage])

    // change 3 — fetch controls and rules when bookingId changes
    useEffect(() => {
        if (!data.bookingId) {
            setAvailableControls([])
            setAvailableRules([])
            return
        }

        demurrageControlService
            .filter(`/by-booking/${data.bookingId}`)
            .then(res => {
                if (res.name === 'AxiosError' || !res) {
                    setAvailableControls([])
                    return
                }
                setAvailableControls(
                    res.map(c => ({
                        label: c.InvoiceCompany
                            ? `${c.InvoiceKey} — ${c.InvoiceCompany}`
                            : c.InvoiceKey || `Control #${c.Id}`,
                        value: c.Id.toString()
                    }))
                )
            })
            .catch(() => setAvailableControls([]))

        demurrageRuleService
            .filter(`/by-booking/${data.bookingId}`)
            .then(res => {
                if (res.name === 'AxiosError' || !res) {
                    setAvailableRules([])
                    return
                }
                setAvailableRules(
                    res.map(r => ({
                        label: r.Description
                            ? `${r.Key} — ${r.Description}`
                            : `Key ${r.Key}`,
                        value: r.Id.toString()
                    }))
                )
            })
            .catch(() => setAvailableRules([]))

    // eslint-disable-next-line
    }, [data.bookingId])

    

    const sessionStorageMachine = (id, key, value) => {
        if (eval(value) instanceof Object && Object.keys(eval(value)).length === 0) return
        if (eval(value) instanceof String && eval(value) === '') return
        if (eval(value) instanceof Number && eval(value) === '') return

        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
        } else {
            // eslint-disable-next-line
            sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
        }
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
        const tempD = JSON.parse(sessionStorage.getItem(`${sessionID}data`))
        const tempOS = JSON.parse(sessionStorage.getItem(`${sessionID}open`))
        const tempPR = JSON.parse(sessionStorage.getItem(`${sessionID}passedRow`))
        const tempLP = JSON.parse(sessionStorage.getItem(`${sessionID}leavingPage`))

        if ((tempO && tempO !== '') || (tempD && Object.keys(tempD).length !== 0) || tempOS || (tempPR && Object.keys(tempD).length !== 0)) {

            setOperation(new String(tempO))
            setData(new Object(tempD))
            setOpen(tempOS)
            setPassedRow(tempPR)
            setLeavingPage(tempLP || false)
            ctx.setIsLoad(false)

            return
        }
        get()
    }

    const get = () => {
        ctx.setIsLoad(false)
    }

    const refreshDemurrage = () => {
        ctx.setIsLoad(true)
        
        sessionKeys.forEach(key => {
            sessionStorage.removeItem(`${id}${key}`)
        })
        
        // Initial values
        setData({})
        setPassedRow({})
        setOpen(false)
        setOperation('')
        setLeavingPage(false)
        setIsEditMode(false)
        setEditingId(null) 
        
        get()
        
        ctx.setIsLoad(false)
        ctx.toastMessages('success', t('Form refreshed'), '')    
    }

    const onSave = () => {
        // Validations
        console.log(data)
        if (!data.lineCode || !data.mServiceCode || !data.motherBound || !data.voyage || !data.bkProcKey || !data.bookingNumber || !data.eqTypeID || !data.number || data.cd == null || data.cd === '' || !data.startDate || !data.demuKey) {
            ctx.toastMessages('error', '', t('Missing required fields'))
            return
        }

        const createDateIfExists = (dateString) => {
            if (!dateString) return null;
            const date = new Date(dateString);
            return isNaN(date.getTime()) ? null : date;
        }

        const startDate = createDateIfExists(data.startDate);
        const midDate = createDateIfExists(data.midDate);
        const endDate = createDateIfExists(data.endDate);

        if (!startDate) {
            ctx.toastMessages('error', '', t('Invalid Start Date'))
            return
        }
        if (endDate) {
            if (endDate <= startDate) {
                ctx.toastMessages('error', '', t('End date must be after Start date.'))
                return
            }
            
            if (midDate && midDate > endDate) {
                ctx.toastMessages('error', '', t('Mid date must be equal to or before End date.'))
                return
            }
        }
        if (midDate && midDate < startDate) {
            ctx.toastMessages('error', '', t('Mid date must be after Start date.'))
            return
        }
        
        const demurrageData = {
            // Booking fields
            TradeId: data.lineCodeId,
            TradeLineName: data.lineCode,
            VoyageId: data.voyageId,
            VoyageNumber: data.voyage,
            BookingId: data.bookingId || data.bkProcKeyId,
            
            // Demurrage Rule
            DemurrageRuleId: parseInt(data.demuKeyId),

            StartDate: data.startDate,
            MidDate: data.midDate || null,
            EndDate: data.endDate || null,
            
            // Statuses
            TerminalStatus: data.terminalStatus,
            Status: data.demurrageStatus,
            
            // Cost fields
            FreeDays: parseInt(data.freeDays),
            Cost: parseFloat(data.cost),
            CostApply: data.fixedCost || false,
            CostPrice: parseFloat(data.priceDiscount) || 0,
            DiscountType: data.discountType,
            
            // Account IDs
            ClientID: data.clientCodeId,
            ClientName: data.clientCode,
            InvoiceID: data.invoiceCodeId,
            InvoiceName: data.invoiceCode,
            AccountID: data.accountId || data.accountID || null,
            
            // Equipment
            EquipmentID: parseInt(data.equipmentId) || 0,
            
            // Movement IDs
            StartMovementID: data.startMovementId ? parseInt(data.startMovementId) : null,
            MidMovementID: data.midMovementId ? parseInt(data.midMovementId) : null,
            EndMovementID: data.endMovementId ? parseInt(data.endMovementId) : null,
            
            // Comments
            Comments: data.bookingComments || '',
            
            // Movement link
            MovementLinkId: data.movementLinkId ? parseInt(data.movementLinkId) : null,

            //Demurrage Control Id
            DemurrageControlId: data.demuControlId ? parseInt(data.demuControlId) : null
        }
        ctx.setIsLoad(true)

        const savePromise = isEditMode && editingId 
            ? demurrageService.update(editingId, demurrageData)
            : demurrageService.post(demurrageData)
        
        savePromise.then(response => {
            ctx.setIsLoad(false)
            
            if (response.name === 'AxiosError') {
                handleError(response)
                return
            }
            
            // Success
            const successMessage = isEditMode ? `${t('Demurrage')} ${t('updatedSuccessfully')}` : `${t('Demurrage')} ${t('savedSuccessfully')}`
            ctx.toastMessages('success', '', successMessage)
            ctx2.closeTab(JSON.parse(id));

        }).catch(error => {
            ctx.setIsLoad(false)
            handleError(error)
        })
    }

    const editOrCopyDemurrage = (demurrageId, isCopy = false) => {
        ctx.setIsLoad(true)

        // Timeout safety — force-close spinner after 10 seconds
        const timeout = setTimeout(() => ctx.setIsLoad(false), 10000)

        demurrageService.getId(demurrageId).then(async response => {
            if (response.name === 'AxiosError') {
                clearTimeout(timeout)
                ctx.setIsLoad(false)
                ctx.toastMessages('error', '', `${t('Demurrage')} ${t('Failed to load')}`)
                return
            }

            // Mapper — same as before
            const demurrageData = {
                lineCodeId: response.TradeId?.toString(),
                lineCode: response.TradeLineName,
                voyageId: response.VoyageId?.toString(),
                voyage: response.VoyageNumber,
                bookingId: response.BookingId?.toString(),
                bookingNumber: '',
                eqTypeID: response.EqTypeID?.toString(),
                equipmentId: response.EquipmentID?.toString(),
                demuKeyId: response.DemurrageRuleId?.toString(),
                startDate: response.StartDate?.split('T')[0],
                midDate: response.MidDate?.split('T')[0] || null,
                endDate: response.EndDate?.split('T')[0] || null,
                startMovementId: response.StartMovementID?.toString(),
                startMoveKey: response.StartMovementID?.toString(),
                startMoveCode: response.StartMovementID?.toString(),
                midMovementId: response.MidMovementID?.toString(),
                midMoveKey: response.MidMovementID?.toString(),
                midMoveCode: response.MidMovementID?.toString(),
                endMovementId: response.EndMovementID?.toString(),
                endMoveKey: response.EndMovementID?.toString(),
                endMoveCode: response.EndMovementID?.toString(),
                demurrageStatus: response.Status?.toString(),
                terminalStatus: response.TerminalStatus?.toString(),
                accountId: response.AccountID?.toString(),
                clientCodeId: response.ClientID?.toString(),
                clientCode: response.ClientName,
                invoiceCodeId: response.InvoiceID?.toString(),
                invoiceCode: response.InvoiceName,
                cost: response.Cost,
                fixedCost: response.CostApply || false,
                freeDays: response.FreeDays?.toString(),
                priceDiscount: response.CostPrice,
                discountType: response.DiscountType?.toString(),
                bookingComments: response.Comments || '',
                movementLinkId: response.MovementLinkId?.toString(),
                demuControlId: response.DemurrageControlId?.toString(),
                _isCopy: isCopy,
                _originalId: isCopy ? demurrageId : null
            }

            // Build all secondary fetches as promises
            const secondaryFetches = []

            if (response.TradeId) {
                secondaryFetches.push(
                    tradeService.getId(response.TradeId).then(tradeRes => {
                        if (tradeRes.name !== 'AxiosError') {
                            const mappedBound = motherBoundMap[tradeRes.TradeBound] || tradeRes.TradeBound || ''
                            demurrageData.lineCode = tradeRes.TradeLineName
                            demurrageData.mServiceCode = tradeRes.TradeCode
                            demurrageData.motherBound = mappedBound
                            demurrageData.motherBoundValue = mappedBound
                        }
                    })
                )
            }

            if (response.VoyageId) {
                secondaryFetches.push(
                    voyageService.getId(response.VoyageId).then(voyageRes => {
                        if (voyageRes.name !== 'AxiosError') {
                            demurrageData.voyage = voyageRes.VoyageNumber
                        }
                    })
                )
            }

            if (response.BookingId) {
                secondaryFetches.push(
                    bookingService.filter(`?filter=Id eq ${response.BookingId}`).then(bookingRes => {
                        console.log('Booking fetch response:', bookingRes) 
                        if (bookingRes.name !== 'AxiosError' && bookingRes.Items?.length > 0) {
                            const booking = bookingRes.Items[0]
                            console.log('Booking item:', booking)
                            demurrageData.bookingNumber = booking.BookingNumber
                            demurrageData.bkProcKey = booking.ProcessKey  // ← make sure this is here
                            demurrageData.bookingId = booking.Id?.toString()
                        }
                    })
                )
            }

            if (response.EquipmentID) {
                secondaryFetches.push(
                    equipmentService.getId(response.EquipmentID).then(equipmentRes => {
                        if (equipmentRes.name !== 'AxiosError') {
                            demurrageData.prefix = equipmentRes.Prefix
                            demurrageData.number = equipmentRes.Number?.toString()
                            demurrageData.cd = equipmentRes.CheckDigit?.toString()
                            demurrageData.equipmentId = equipmentRes.Id?.toString()
                            demurrageData.eqTypeID = equipmentRes.EquipmentTypeCode
                        }
                    })
                )
            }

            if (response.DemurrageRuleId) {
                secondaryFetches.push(
                    demurrageRuleService.getId(response.DemurrageRuleId).then(ruleRes => {
                        if (ruleRes.name !== 'AxiosError') {
                            demurrageData.demuKey = ruleRes.Key
                            demurrageData.description = ruleRes.Description
                        }
                    })
                )
            }

            if (response.StartMovementID) {
                secondaryFetches.push(
                    movementService.getId(response.StartMovementID).then(movRes => {
                        if (movRes.name !== 'AxiosError') {
                            demurrageData.startMoveCode = movRes.Status
                        }
                    })
                )
            }

            if (response.MidMovementID) {
                secondaryFetches.push(
                    movementService.getId(response.MidMovementID).then(movRes => {
                        if (movRes.name !== 'AxiosError') {
                            demurrageData.midMoveCode = movRes.Status
                        }
                    })
                )
            }

            if (response.EndMovementID) {
                secondaryFetches.push(
                    movementService.getId(response.EndMovementID).then(movRes => {
                        if (movRes.name !== 'AxiosError') {
                            demurrageData.endMoveCode = movRes.Status
                        }
                    })
                )
            }

            if (response.AccountID) {
                secondaryFetches.push(
                    accountService.getId(response.AccountID).then(accountRes => {
                        if (accountRes.name !== 'AxiosError') {
                            demurrageData.accountID = accountRes.AccountName
                        }
                    })
                )
            }

            if (response.ClientID) {
                secondaryFetches.push(
                    accountService.getId(response.ClientID).then(clientRes => {
                        if (clientRes.name !== 'AxiosError') {
                            demurrageData.clientCode = clientRes.AccountName
                        }
                    })
                )
            }

            if (response.InvoiceID) {
                secondaryFetches.push(
                    accountService.getId(response.InvoiceID).then(invoiceRes => {
                        if (invoiceRes.name !== 'AxiosError') {
                            demurrageData.invoiceCode = invoiceRes.AccountName
                        }
                    })
                )
            }

            // Wait for ALL secondary fetches to complete before setting data
            await Promise.all(secondaryFetches)

            if (isCopy) {
                delete demurrageData.Id
                delete demurrageData.ExternalId
                delete demurrageData.CreatedAt
                delete demurrageData.UpdatedAt
                setIsEditMode(false)
                setEditingId(null)
                setOperation('Create')
            } else {
                setIsEditMode(true)
                setEditingId(demurrageId)
                setOperation('Edit')
            }

            // Only now — all data is ready, set it all at once and stop the spinner
            setData(demurrageData)
            clearTimeout(timeout)
            ctx.setIsLoad(false)

        }).catch(error => {
            clearTimeout(timeout)
            ctx.setIsLoad(false)
            console.error('Error loading demurrage:', error)
            ctx.toastMessages('error', '', `${t('Demurrage')} ${t('Failed to load')}`)
        })
    }


    const handleError = (error) => {
        let errorMessage = `${t('Error saving')} ${t('Demurrage')}`
        const data = error.response?.data

        if (Array.isArray(data)) {
            errorMessage = data.map(e => `${e.field}: ${e.message}`).join('\n')
        } else if (data?.errors) {
            errorMessage = Object.entries(data.errors)
                .map(([field, messages]) => `${field}: ${messages.join(', ')}`)
                .join('; ')
        } else if (data?.message) {
            errorMessage = data.field ? `${data.field}: ${data.message}` : data.message
        } else if (data?.detail) {
            errorMessage = data.detail
        } else if (data?.title) {
            errorMessage = data.title
        } else if (error.message) {
            errorMessage = error.message
        }

        ctx.toastMessages('error', '', errorMessage)
    }


    return (
        <div >
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            label={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable" style={{ width: '20px', color: ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)' }}></i>}
                            onClick={() => { setLeavingPage(true) }}
                        />
                        <M_Button
                            tooltip={t("Refresh")}
                            icon={<Refresh />}
                            label={t("Refresh")}
                            onClick={() => refreshDemurrage()}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save "></i>}
                            label={t("Save")}
                            onClick={() => onSave()}
                        />
                    </>
                }
            />
            <div style={{ margin: '20px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: !matches10 && 'auto' || 'auto auto' }}>
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><Book style={{ marginRight: '10px', scale: '1.3' }} /> {t("Booking")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {BookingFields.map((field, index) => {
                                    if (field.type === 'separator') {
                                        //New line
                                        return <div key={`separator-${index}`} style={{ gridColumn: '1 / -1', height: '0' }} />;
                                    }
                
                                    if (field.fullWidth) {
                                        return (
                                            <div key={index} style={{ gridColumn: '1 / -1', width: '100%', marginTop: '10px' }}>
                                                {fields(field, index, data, setData, false, null, '100%', null, null, null, null, null, fieldFilterMap[field.code] || null)}
                                            </div>
                                        );
                                    }
                                    return fields(
                                        field, index, data, setData, 
                                        null, 
                                        field.returnFunc || null, 
                                        '250px', 
                                        field.type === 'select' ? motherBoundOptions : null,  // ← only for select fields
                                        null, null, null, null, 
                                        fieldFilterMap[field.code] || null
                                    )                             
                                })}
                            </div>
                        }
                    />
                    <M_Fieldset
                        labelInside
                        label={<div style={{ display: 'flex', alignItems: 'center', fontSize: '25px', marginLeft: '10px' }}><TimerOutlined  style={{ marginRight: '10px', scale: '1.3' }} /> {t("Demurrage")}</div>}
                        elements={
                            <div style={{ display: 'grid', gridTemplateColumns: !matches15 && 'auto' || !matches13 && 'auto auto' || 'auto auto auto', justifyContent: 'space-evenly' }}>
                                {DemurrageFields.map((field, index) => {
                                    return fields(field, index, data, setData, null, field.returnFunc, null, fieldOptionsMap[field.code])
                                })}
                            </div>
                        }
                    />
                </div>
                <div style={{ margin: '25px' }}></div>
            </div >
            <M_MessageBoard
                warning
                open={leavingPage}
                title={t("leavingPageTitle")}
                body={t("leavingPageBody")}
                footer={
                    <span style={{ display: 'flex', alignItems: 'center' }}>
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setLeavingPage(false)} label={t("ButtonCancel")} />
                        <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={() => ctx2.closeTab(JSON.parse(id))} label={t("ButtonConfirm")} />
                    </span>
                }
            />
        </div >
    )
}